import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useRef, useState } from 'react';
import { flatten } from 'lodash';
import { IconArrowsRight, IconRefresh, defineAnimatedIcon } from '@carnica/graphics';
import { BTN_TEXT_MORE_VARIANTS, STEP_FOR_SLICE } from "../../../../../shared/config";
import { useScrollContext } from "../../../../../shared/model";
import { prepareQuickReplies } from "../../../../../entities/content/lib";
import { EBtnTypeAnalytics, ymPushSendClickQuickButton, ymPushSendViewQuickButton } from "../../../../../shared/analytics";
var prepareQuickRepliesForAnalytics = function prepareQuickRepliesForAnalytics(flex, fixed, isMoreVariant) {
  var prepareFlex = (flex === null || flex === void 0 ? void 0 : flex.map(function (item) {
    return item === null || item === void 0 ? void 0 : item.text;
  })) || [];
  var prepareFixed = (fixed === null || fixed === void 0 ? void 0 : fixed.map(function (item) {
    return item === null || item === void 0 ? void 0 : item.text;
  })) || [];
  if (isMoreVariant) {
    prepareFlex.push(BTN_TEXT_MORE_VARIANTS);
  }
  return prepareFlex.concat(prepareFixed);
};
export var useQuickReplies = function useQuickReplies(itemsProp) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    slice = _useState2[0],
    setSlice = _useState2[1];
  var prevPosition = useRef(-1);
  var _useScrollContext = useScrollContext(),
    scrollToBottom = _useScrollContext.scrollToBottom;
  var _useMemo = useMemo(function () {
      return prepareQuickReplies({
        items: flatten(itemsProp),
        slice: slice
      });
    }, [itemsProp, slice]),
    flexListByPage = _useMemo.flexListByPage,
    lengthFlexList = _useMemo.lengthFlexList,
    fixedList = _useMemo.fixedList,
    isMoreVariant = _useMemo.isMoreVariant;
  var onClick = function onClick() {
    var position = slice + STEP_FOR_SLICE;
    var startPosition = position >= lengthFlexList ? 0 : position;
    setSlice(startPosition);
    ymPushSendClickQuickButton(BTN_TEXT_MORE_VARIANTS, EBtnTypeAnalytics.replies, 'authorized');
    scrollToBottom(100);
  };
  var hasMoreVariants = lengthFlexList - slice > STEP_FOR_SLICE;
  var IconComponent = defineAnimatedIcon({
    icons: [IconArrowsRight, IconRefresh]
  });

  /**
   * Отправки аналитики. Показ быстрых запросов.
   * @see {prepareQuickRepliesForAnalytics} - отправка кнопок на экране с учетом пагинации.
   * Условие if нужно чтобы не было повторных отправок при циклической пагинации.
   * @see {prevPosition} - старт задан -1, чтобы не было повторных отправок при перелистовании.
   * */
  useEffect(function () {
    if (itemsProp !== null && itemsProp !== void 0 && itemsProp.length && prevPosition.current < slice) {
      var list = prepareQuickRepliesForAnalytics(flexListByPage, fixedList, isMoreVariant);
      ymPushSendViewQuickButton(list, EBtnTypeAnalytics.replies, 'authorized');
      prevPosition.current = slice;
    }
  }, [flexListByPage, fixedList]);
  return {
    flexListByPage: flexListByPage,
    fixedList: fixedList,
    isMoreVariant: isMoreVariant,
    IconComponent: IconComponent,
    onClick: onClick,
    hasMoreVariants: hasMoreVariants
  };
};